<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Button from "@/dsComponents/buttons/Button.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

const { t } = useI18n();

const emits = defineEmits<(e: "close") => void>();

defineProps<{
    open: boolean;
}>();

const close = () => {
    emits("close");
};
</script>

<template>
    <Modal :open="open" @close="close" :title="t('modals.tooMuchWorkerConfirm.title')" width="500px" :action="true">
        <p>{{ t("modals.tooMuchWorkerConfirm.description") }}</p>
        <template #footer>
            <div class="button-container">
                <Button size="sm" left-icon="x" @click="close">{{ t("global.actions.close") }}</Button>
            </div>
        </template>
    </Modal>
</template>
<style scoped>
.button-container {
    display: flex;
    justify-content: flex-end;
}
</style>
